import React from 'react';
import { connect } from 'react-redux';

import * as routes from 'app/routes';
import CurrentDue from 'billing/CurrentDue';
import SelectPaymentMethod from 'billing/paymentMethods/SelectPaymentMethod';
import Link from 'common/Link';
import Box from 'common/Box';
import Info from 'notifications/Info';
import billing_icon from 'common/img/billing_icon.svg';
import history_icon from 'common/img/history_icon.svg';

import styles from './index.module.css';


export const Billing = ({ addCard }) => (
  <div>
    <h1>
      Billing
      <img src={billing_icon} alt="" />
    </h1>
    <CurrentDue />
    <div className={styles.links}>
      <Link to={routes.purchaseHistory()}>
        <Box>
            <img src={history_icon} alt="" />
            Billing history
        </Box>
      </Link>
    </div>
    <h2>Payment Methods</h2>
    <SelectPaymentMethod onNewCard={addCard} />
    <Info name="newCard" />
  </div>
);

const mapDispatchToProps = {
  addCard: routes.addCard
}

export default connect(
  null,
  mapDispatchToProps
)(Billing);
